module.exports = __webpack_public_path__ + "static/media/shadow_creek_cellar_door.6f00033c.jpg";